import { getHolydays } from "../api/apimethods";
import { Holiday } from "../typings/models/Holiday";

let holidays: Holiday[] = [];

const fetchHolidaysMaster = async () => {
  try {
    const response = await getHolydays();
    holidays = response.data.holidayMasters;
    return holidays; // Resolve the holidays array
  } catch (error) {
    console.error("Error fetching holidays:", error);
    return []; // Return an empty array if there's an error
  }
};

export default fetchHolidaysMaster;